import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import '../CompanyAutoComplete.css';
import { toast } from 'react-toastify';

// Props :
// dropdownList :: array => array of items to show in the dropdown
// dropdownValue :: string => Array list value name on which values showing in the dropdown
// searchTerm :: value => value on which dropdown will be filtered

class NewPortAuto extends Component {
  constructor(props) {
    super(props);
    const searchTerm = props.searchTerm || '';
    this.state = {
      searchTerm,
      suggestions: this.filternumbers(searchTerm),
    };
  }

  componentDidUpdate(prevProps) {
    const { searchTerm } = this.props;
    if (searchTerm !== prevProps.searchTerm) {
      this.setState({ searchTerm: searchTerm || '' });
    }
  }

  filternumbers = value => {
    const inputValue = value.trim().toLowerCase();
    const { dropdownList, dropdownValue } = this.props; // array of items to show
    return dropdownList?.filter(item => {
      if (dropdownValue) {
        return item[dropdownValue].toLowerCase().includes(inputValue);
      }
      if (typeof item === 'number')
        JSON.stringify(item)
          .toLowerCase()
          .includes(inputValue);
      else item.toLowerCase().includes(inputValue);
    });
  };

  getNumberValue = item => {
    const { dropdownValue } = this.props; // array of items to show
    if (dropdownValue) {
      return item[dropdownValue];
    }
    return item;
  };

  renderSuggestion = item => {
    const { dropdownValue, disabledSeries } = this.props; // array of items to show
    if (dropdownValue) {
      const isDisabled = disabledSeries?.find(ev => ev.newPort === item[dropdownValue] - 1);
      const className = isDisabled ? 'disabled-suggestion' : '';
      return <div className={className}>{item[dropdownValue]}</div>;
    }
    return <div>{item}</div>;
  };

  onChange = (event, { newValue }) => {
    const { dropdownValue, disabledSeries, onChange } = this.props;
    const isDisabled = disabledSeries?.find(item => item.newPort === newValue - 1);
    if (isDisabled) {
      toast.error('This port is already selected');
    } else {
      if (newValue === '' || newValue === undefined) {
        onChange({
          name: dropdownValue || newValue,
          value: null,
          suggestion: null,
        });
      }
      this.setState({
        searchTerm: newValue,
      });
    }
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.filternumbers(value),
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  onNumberSelected = (ev, { suggestion, suggestionValue }) => {
    const { dropdownValue, onChange } = this.props;
    const evObj = { name: dropdownValue, value: suggestionValue, suggestion };
    onChange(evObj);
  };

  onKeyPress = e => {
    const { dropdownList, dropdownValue, onChange } = this.props;
    if (e.key === 'Enter' && dropdownValue) {
      const suggestion = dropdownList.filter(item => item[dropdownValue] === e.currentTarget.value);
      onChange({
        name: dropdownValue,
        value: e.currentTarget.value,
        suggestion: { ...suggestion[0] },
      });
    }
  };

  render() {
    const { searchTerm, suggestions } = this.state;
    const { dropdownValue, placeholder, isDisabled, editStatus, className } = this.props;
    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: placeholder || 'Search Number...',
      disabled: isDisabled || editStatus,
      value: searchTerm,
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      name: dropdownValue || 'dynamicDropdown',
      requires: 'true',
      type: 'text',
      className: 'form-control',
    };

    // Finally, render it!
    return (
      <div className={className || 'autocomplete-container'}>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={this.getNumberValue}
          renderSuggestion={this.renderSuggestion}
          inputProps={inputProps}
          shouldRenderSuggestions={() => true}
          onSuggestionSelected={this.onNumberSelected}
        />
      </div>
    );
  }
}

export default NewPortAuto;
